var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconaStoricoOrdini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38141 12.2917H3.72413C2.99035 12.2917 2.3955 11.6969 2.39551 10.9631L2.39556 2.99134C2.39556 2.25756 2.99041 1.66272 3.72419 1.66272H9.70319C10.437 1.66272 11.0318 2.25757 11.0318 2.99135V6.64509M8.37456 10.4095L9.59247 11.6275L12.2497 8.97009M4.72082 4.31998H8.70672M4.72082 6.31293H8.70672M4.72082 8.30588H6.71377",
    stroke: "white",
    strokeWidth: 1.10719,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaStoricoOrdini);
export default __webpack_public_path__ + "static/media/icona-storico-ordini.1cdb4cc7243ea21133822f177c4a0110.svg";
export { ForwardRef as ReactComponent };